module.exports = __webpack_public_path__ + "static/media/foundationexams.3ae269c0.png";